// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NV6t","name":"styles_name__cBiMa","phone":"styles_phone__tIg66"};